/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorAvailabilitySlot from './doctor-availability-slot';
import DoctorAvailabilitySlotDetail from './doctor-availability-slot-detail';
import DoctorAvailabilitySlotUpdate from './doctor-availability-slot-update';
import DoctorAvailabilitySlotDeleteDialog from './doctor-availability-slot-delete-dialog';

const DoctorAvailabilitySlotRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorAvailabilitySlot />} />
    <Route path="new" element={<DoctorAvailabilitySlotUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorAvailabilitySlotDetail />} />
      <Route path="edit" element={<DoctorAvailabilitySlotUpdate />} />
      <Route path="delete" element={<DoctorAvailabilitySlotDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorAvailabilitySlotRoutes;
